import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/teachersDay/Index.vue')
const Trend = () => import('../activity/teachersDay/Trend.vue')
const Videos = () => import('../activity/teachersDay/Videos.vue')
const Share = () => import('../activity/teachersDay/Share.vue')
const Landing = () => import('../activity/teachersDay/Landing.vue')

export const IndexRoute: RouteConfig = {
  path: '/teachers-day',
  name: 'teachers_day',
  component: Index,
  meta: {
    title: '教师节快乐',
  },
}

export const TrendRoute: RouteConfig = {
  path: '/teachers-day/trend',
  name: 'teachers_day_trend',
  component: Trend,
  meta: {
    title: '教师人气榜',
  },
}
export const VideosRoute: RouteConfig = {
  path: '/teachers-day/videos',
  name: 'teachers_day_videos',
  component: Videos,
  meta: {
    title: '视频祝福墙',
  },
}

export const ShareRoute: RouteConfig = {
  path: '/teachers-day/share',
  name: 'teachers_day_share',
  component: Share,
  props: (route) => ({ id: route.query.id }),
  meta: {
    title: '任务分享',
  },
}

export const LandingRoute: RouteConfig = {
  path: '/teachers-day/landing',
  name: 'teachers_day_landing',
  component: Landing,
  meta: {
    title: '教师节活动',
  },
}

export default [IndexRoute, TrendRoute, VideosRoute, ShareRoute, LandingRoute]
